import React from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import Token from 'utils/token/Token';
import MainLayout from './MainLayout';
import Login from './Login/Login';

const { localStorage } = window;

const RootWrapper = () => {
  const userStorage = localStorage.getItem('user');

  /**
   * Logic to check the userStorage (isLogged) and check if is a refresh to refresh the token
   * @returns {*}
   */
  const handleRootWrapperLogin = () => {
    // is is true so the user is logged.
    if (userStorage) {
      const token = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refresh_token');
      const isLogged = localStorage.getItem('isLogged');
      // this is only for login so we remove it.
      if (isLogged) {
        localStorage.removeItem('isLogged');
      } else {
        // if the app is refreshed and the isLogged doesn't exist so do the refresh method.
        Token.refreshToken(refreshToken)
          .then((res) => {
            if (res.data.token && res.data.refresh_token) {
              localStorage.setItem('token', res.data.token);
              localStorage.setItem('refresh_token', res.data.refresh_token);
            } else {
              message.error('Falló el refresh código de error: 007');
            }
          })
          .catch((err) => message.error(`${err}`));
      }
      // send the token from local storage to child components.
      return <MainLayout token={token} />;
    }
    return (
      <Login />
    );
  };
  return (
    <div>
      {handleRootWrapperLogin()}
    </div>
  );
};

// refresh the entire app when the token is added from login
const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps, {})(RootWrapper);
